import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Logo } from "@/components/site/Logo";
import { Field, inputCls } from "@/components/landing/ProposalForm";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/painel" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/painel");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="grain relative grid min-h-screen lg:grid-cols-2" data-testid="login-page">
      <div className="relative hidden overflow-hidden lg:block">
        <img src="/img/lens.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-tr from-violet-deep/90 via-ink/40 to-flash/30" />
        <p className="absolute bottom-12 left-12 max-w-md font-display text-5xl font-extrabold leading-[0.95]">Área dos fotógrafos associados.</p>
      </div>
      <div className="flex flex-col justify-center px-6 py-16 sm:px-16">
        <Logo />
        <h1 className="mt-12 font-display text-4xl font-bold">Entrar</h1>
        <p className="mt-2 text-haze">Acesso para a equipe e fotógrafos associados.</p>
        <p className="mt-2 text-sm text-haze lg:hidden">Gerencie eventos, fotos, pedidos e orçamentos.</p>
        <form onSubmit={submit} className="mt-10 grid max-w-md gap-5" data-testid="login-form">
          <Field label="E-mail"><input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="login-email-input" /></Field>
          <Field label="Senha"><input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="login-password-input" /></Field>
          {error && <p className="text-sm text-red-300" data-testid="login-error">{error}</p>}
          <button disabled={busy} className="inline-flex items-center justify-center gap-2 rounded-full bg-flash px-6 py-4 font-semibold text-ink hover:bg-flash-2 disabled:opacity-60" data-testid="login-submit-btn">
            {busy && <Loader2 className="h-5 w-5 animate-spin" />} Entrar
          </button>
        </form>
      </div>
    </main>
  );
}
